<template>
  <b-container>
    <div class="body-wrapper">
      <div class="body-title">
        <h5 style="color: #2284ab">View Results</h5>
      </div>
      <div class="body-content">
        <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
        <b-alert
          :show="showDismissibleAlert"
          dismissible
          @dismissed="showDismissibleAlert = false"
          :variant="variant"
          >{{ alertText }}</b-alert
        >
        <b-row>
          <b-col md="6" style="font-size: 0.85rem">
            <b>NAME</b>: {{ meritlist[0].FullName }}
          </b-col>
          <b-col md="3" style="font-size: 0.85rem">
            <b>CATEGORY</b> : {{ meritlist[0].CategoryName }}
          </b-col>
          <b-col md="3" style="font-size: 0.85rem">
            <b>CASTE</b> : {{ meritlist[0].SubCaste }}
          </b-col>
        </b-row>
        <b-table
          show-empty
          head-variant="dark"
          empty-text="No List available at this time. Keep Looking this space."
          stacked="md"
          bordered
          striped
          :items="meritlist"
          :fields="fieldsMerit"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @filtered="onFiltered"
          style="font-size: 12px"
          class="mt-3"
        >
          <!-- <template slot="ResultStatus" slot-scope="row">{{
            row.value ? "Pass" : "Failed"
          }}</template>
          <template slot="RunningMark" slot-scope="row">{{
            row.value < 0 ? "Exempted" : row.value
          }}</template>
          <template slot="PullupsMark" slot-scope="row">{{
            row.value < 0 ? "Exempted" : row.value
          }}</template>
          <template slot="SitupsMark" slot-scope="row">{{
            row.value < 0 ? "Exempted" : row.value
          }}</template>
          <template slot="TotalMarks" slot-scope="row">{{
            row.value < 0 ? "Exempted" : row.value
          }}</template> -->
        </b-table>
        <p><strong>Notes:</strong></p>
        <b-row
          v-for="application in meritlist"
          :key="application.UserAppllicationID"
        >
          <b-col
            class="col-md-12"
            v-if="application.TotalMarks == 'Conditional Exempted'"
            style="text-align: left; color: red; font-size:0.875rem"
          >
            <strong>{{ application.ApplicationNo }}</strong> : THIS APPLICATION IS APPROVED ON
            CONDITIONAL BASIS - CANDIDATE'S GROUND TEST IS PENDING
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="body-wrapper">
      <div class="body-title">
        <h5 style="color: #2284ab">
          Physical, Ground and Education Marks Criteria
        </h5>
      </div>
      <div class="body-content">
        <h5>Physical Requirements</h5>
        <!-- <p> -->
        <ui
          >For Male candidate:
          <li>minimum height of 162 cm.</li>
          <li>minimum weight of 50 kg.</li>
          <li>Chest (deflated) 79 cm. minimum</li>
          <li>Chest (Inflated) 84 cm. minimum</li>
          <li>Candidate must be able to inflate his Chest, atleast by 5 cm.</li>
        </ui>
        <br />
        <ui
          >For Female candidate:
          <li>minimum height of 155 cm.</li>
          <li>minimum weight of 48 kg.</li>
        </ui>
        <!-- </p> -->

        <h5 class="mt-1">Outdoor Tests</h5>
        <!-- <p> -->
        <li>
          Sprint - 400 mtr. For Male
          <ul style="margin-left: 5%">
            <li>1min. 30 sec. - 12 marks;</li>
            <li>1 min. 35 sec. - 10 marks;</li>
            <li>1 min. 40 sec. - 8 marks;</li>
            <li>1 min. 45 sec. - 6 marks;</li>
            <li>1 min. 50 sec. - 4 marks;</li>
            <li>1 min. 55 sec. - 2 marks;</li>
          </ul>
        </li>

        <li>
          Sprint - 200 mtr. For Female
          <ul style="margin-left: 5%">
            <li>1 min. 30 sec. - 12 marks;</li>
            <li>1 min. 35 sec. - 10 marks;</li>
            <li>1 min. 40 sec. - 8 marks;</li>
            <li>1 min. 45 sec. - 6 marks;</li>
            <li>1 min. 50 sec. - 4 marks;</li>
            <li>1 min. 55 sec. - 2 marks;</li>
          </ul>
        </li>

        <ui>
          <li>For Male, 8 PULLUPS - 8 Marks</li>
          <li>for Female, 4 PULLUPS - 8 Marks</li>
        </ui>
        <ui>
          <li>For Male, 10 SITUPS - 10 Marks</li>
          <li>For Female, 10 SITUPS - 10 Marks</li>
        </ui>
        <li>
          To pass the outdoor test, the candidate must get atleast 20 marks.
        </li>
        <!-- </p> -->

        <h5 class="mt-2 mb-1">Educational Marks</h5>
        <table style="border: none; border-collapse: collapse">
          <colgroup>
            <col width="161" />
            <col width="101" />
            <col width="112" />
            <col width="114" />
            <col width="114" />
          </colgroup>
          <tbody>
            <tr style="height: 24pt">
              <td
                rowspan="2"
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >Qualification</span
                  >
                </p>
              </td>
              <td
                colspan="4"
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >Marks for Merit List</span
                  >
                </p>
              </td>
            </tr>
            <tr style="height: 24pt">
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >First Class</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >Second Class</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >Pass Class</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >Fail</span
                  >
                </p>
              </td>
            </tr>
            <tr style="height: 0pt">
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >Graduation and Above</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >10</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >9</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >8</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >7</span
                  >
                </p>
              </td>
            </tr>
            <tr style="height: 0pt">
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >HSC /12th</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >7</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >6</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >5</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >4</span
                  >
                </p>
              </td>
            </tr>
            <tr style="height: 0pt">
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >SSC /10th</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >4</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >3</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >2</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >1</span
                  >
                </p>
              </td>
            </tr>
            <tr style="height: 0pt">
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >8th
                  </span>
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >1</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >1</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >1</span
                  >
                </p>
              </td>
              <td
                style="
                  border-left: solid #000000 1pt;
                  border-right: solid #000000 1pt;
                  border-bottom: solid #000000 1pt;
                  border-top: solid #000000 1pt;
                  vertical-align: top;
                  padding: 5pt 5pt 5pt 5pt;
                  overflow: hidden;
                  overflow-wrap: break-word;
                "
              >
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    text-align: center;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                  "
                >
                  <span
                    style="
                      font-size: 12pt;
                      font-family: Calibri, sans-serif;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre;
                      white-space: pre-wrap;
                    "
                    >0</span
                  >
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <p
          dir="ltr"
          style="line-height: 1.2; margin-top: 0pt; margin-bottom: 10pt"
        >
          <span
            style="
              font-size: 12pt;
              font-family: Calibri, sans-serif;
              color: #000000;
              background-color: transparent;
              font-weight: 700;
              font-style: normal;
              font-variant: normal;
              text-decoration: none;
              vertical-align: baseline;
              white-space: pre;
              white-space: pre-wrap;
            "
            >Note:</span
          >
          <span
            style="
              font-size: 12pt;
              font-family: Calibri, sans-serif;
              color: #000000;
              background-color: transparent;
              font-weight: 400;
              font-style: normal;
              font-variant: normal;
              text-decoration: none;
              vertical-align: baseline;
              white-space: pre;
              white-space: pre-wrap;
            "
          >
          </span>
        </p>
        <ol style="margin-top: 0; margin-bottom: 0; padding-inline-start: 48px">
          <li
            dir="ltr"
            style="
              list-style-type: decimal;
              font-size: 12pt;
              font-family: Calibri, sans-serif;
              color: #000000;
              background-color: transparent;
              font-weight: 400;
              font-style: normal;
              font-variant: normal;
              text-decoration: none;
              vertical-align: baseline;
              white-space: pre;
            "
            aria-level="1"
          >
            <p
              dir="ltr"
              style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
              role="presentation"
            >
              <span
                style="
                  font-size: 12pt;
                  font-family: Calibri, sans-serif;
                  color: #000000;
                  background-color: transparent;
                  font-weight: 400;
                  font-style: normal;
                  font-variant: normal;
                  text-decoration: none;
                  vertical-align: baseline;
                  white-space: pre;
                  white-space: pre-wrap;
                "
                >Candidates who have completed 12th, but have not completed
                Graduation will be considered as 12th Pass.</span
              >
            </p>
          </li>
          <li
            dir="ltr"
            style="
              list-style-type: decimal;
              font-size: 12pt;
              font-family: Calibri, sans-serif;
              color: #000000;
              background-color: transparent;
              font-weight: 400;
              font-style: normal;
              font-variant: normal;
              text-decoration: none;
              vertical-align: baseline;
              white-space: pre;
            "
            aria-level="1"
          >
            <p
              dir="ltr"
              style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
              role="presentation"
            >
              <span
                style="
                  font-size: 12pt;
                  font-family: Calibri, sans-serif;
                  color: #000000;
                  background-color: transparent;
                  font-weight: 400;
                  font-style: normal;
                  font-variant: normal;
                  text-decoration: none;
                  vertical-align: baseline;
                  white-space: pre;
                  white-space: pre-wrap;
                "
                >Candidates who have completed 11th Std and not appeared for
                12th will be considered as 10th Pass.</span
              >
            </p>
          </li>
          <li
            dir="ltr"
            style="
              list-style-type: decimal;
              font-size: 12pt;
              font-family: Calibri, sans-serif;
              color: #000000;
              background-color: transparent;
              font-weight: 400;
              font-style: normal;
              font-variant: normal;
              text-decoration: none;
              vertical-align: baseline;
              white-space: pre;
            "
            aria-level="1"
          >
            <p
              dir="ltr"
              style="line-height: 1.2; margin-top: 0pt; margin-bottom: 10pt"
              role="presentation"
            >
              <span
                style="
                  font-size: 12pt;
                  font-family: Calibri, sans-serif;
                  color: #000000;
                  background-color: transparent;
                  font-weight: 400;
                  font-style: normal;
                  font-variant: normal;
                  text-decoration: none;
                  vertical-align: baseline;
                  white-space: pre;
                  white-space: pre-wrap;
                "
                >9th Class completed candidates will be considered as 8th class
                pass.</span
              >
            </p>
          </li>
        </ol>
      </div>
    </div>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";

export default {
  components: { Spinner },
  props: ["applicationID"],
  data() {
    return {
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: true,
      isLoading2: false,
      meritlist: [],
      fieldsMerit: [
        { key: "ApplicationNo", label: "Application No", sortable: true },
        { key: "Gender", label: "Gender", sortable: true },
        { key: "height", label: "Height cm" },
        { key: "Weight", label: "Weight kg" },
        { key: "ChestDeflated", label: "Chest Deflated cm" },
        { key: "ChestInflated", label: "Chest Inflated cm" },
        { key: "RunningMark", label: "Running Marks" },
        { key: "PullupsMark", label: "Pullup Marks" },
        { key: "SitupsMark", label: "Situp Marks" },
        { key: "GroundMarks", label: "Total Outdoor Test Marks" },
        { key: "EducationalMark", label: "Education Marks" },
        { key: "TotalMarks", label: "Total Marks" },
        // { key: "ResultStatus", label: "Result" }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      selectedEventId: "",
      RegType: 0,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showDetails() {
      var userinfo = this.$store.getters.loggedUser;
      var UserId = userinfo.UserId;
      let promise = apis.getMeritbyApplicationID(UserId);
      promise
        .then((response) => {
          if (response.status == 200) {
            console.log("Items", response.body);
            this.isLoading = false;
            this.meritlist = response.body;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
            this.isLoading = false;
            this.itemsa = [];
          }
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
          this.items = [];
        });
    },
  },
  mounted() {
    this.showDetails();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ApplicationStatus/Result.vue